import { isRecordedActivity, movementActivityDate } from './bank-posting';
import { splitPeriodWeekRanges } from './periods';
import type { Movement, WeekId } from './types';

export type SpendingScope = WeekId | 'fortnight';
export function weeklySpending(movements: Movement[], start: string | undefined, end: string | undefined, scope: SpendingScope, today: string) {
  const ranges = splitPeriodWeekRanges(start, end);
  if (!ranges || !start || !end) return null;
  const range = scope === 'fortnight' ? { start, end } : ranges[scope];
  const rows = [...new Map(movements.map(row => [row.id, row])).values()].filter(row => {
    const date = movementActivityDate(row);
    return row.syncState !== 'failed' && isRecordedActivity(row, today) && date >= range.start && date <= range.end;
  });
  const categories = new Map<string, number>();
  let totalCents = 0, ownCents = 0, reimbursementCents = 0;
  for (const row of rows) {
    const billed = row.billedAmountCents ?? row.amountCents;
    const reimbursement = row.reimbursementCents ?? 0;
    if (![billed, reimbursement].every(value => Number.isSafeInteger(value) && value >= 0) || reimbursement > billed) throw new Error('Hay un importe inválido; actualiza antes de consultar el resumen.');
    totalCents += billed; ownCents += billed - reimbursement; reimbursementCents += reimbursement;
    if (![totalCents, ownCents, reimbursementCents].every(Number.isSafeInteger)) throw new Error('El total supera el límite permitido.');
    const category = row.category?.trim() || 'Sin categoría';
    categories.set(category, (categories.get(category) ?? 0) + billed);
  }
  return { range, movements: rows, totalCents, ownCents, reimbursementCents,
    categories: [...categories].filter(([, amount]) => amount > 0).map(([name, amountCents]) => ({ name, amountCents, icon: '' })) };
}
